import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {useHistory, useLocation} from "react-router-dom";
import {AuthXService} from "@brg/auth";
import {AppTester} from "../../../../supporting";
import {useContextsTabs} from "../../../hooks/useContextsTabs";
import {useMemo} from "react";
import { isServer } from "shared/constants/isServer";

export const useGetHseDesignContexts = () => {

    const {
        isHSEDesign,
        isLMSHSE,
        isProHSE,
        isExamHSE,
        isStartHSE,
    } = useAppTester();
    const isHseColors = AppTester.isContext('hsecolors')
    const { context: currentContext } = useContextsTabs();
    const { pathname } = useLocation();
    const isHSEMain = isHSEDesign && ! isLMSHSE && !isProHSE && !isExamHSE && !isHseColors && !isStartHSE;
    const isVirtualSpace = pathname === '/teams/virtualspace' || pathname.startsWith('/teams/virtualspace/');

    const {
        REACT_APP_URL_HSEDESIGN_COM,
        REACT_APP_URL_HSEDESIGN_RU,
        REACT_APP_URL_HSEDESIGN_LMS_COM,
        REACT_APP_URL_HSEDESIGN_LMS,
        REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU,
        REACT_APP_URL_EXAMS,
        REACT_APP_URL_EXAMS_COM,
        REACT_APP_URL_HSEDESIGN_START_COM,
        REACT_APP_URL_HSEDESIGN_START_RU,
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const hostIsCom = !isServer && window.location.origin.includes('com');
    const history = useHistory()

    const links = useMemo(() => ([
        {
            id: ContextCodes.hseDesignMain,
            active: Boolean(currentContext === 'hsedesign_main'),
            content: 'portfolio',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseBooks,
            active: Boolean(currentContext === 'hsebooks'),
            content: 'books',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/hsebooks' + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/hsebooks')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/hsebooks' + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseAnimation,
            active: Boolean(currentContext === 'hseanimation'),
            content: 'animation',
            linkTo: 'https://hseanimation.ru',
            action: () => {
                window.open('https://hseanimation.ru', '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseVisualResearch,
            active: Boolean(currentContext === 'hsevisualresearch'),
            content: 'research',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/visualResearch' + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/visualResearch')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/visualResearch' + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseLMS,
            active: isLMSHSE,
            content: 'lms',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_LMS_COM : REACT_APP_URL_HSEDESIGN_LMS) + suffix,
            action: () => {
                if (isLMSHSE) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_LMS_COM : REACT_APP_URL_HSEDESIGN_LMS) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hsePro,
            active: isProHSE,
            content: 'pro',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_PRO_COM : REACT_APP_URL_HSEDESIGN_PRO_RU) + suffix,
            action: () => {
                if (isProHSE) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_PRO_COM : REACT_APP_URL_HSEDESIGN_PRO_RU) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hsePlaybooks,
            active: Boolean(currentContext === 'hsedesignplaybooks'),
            content: 'playbooks',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/playbooks' + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/playbooks')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/playbooks' + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hsePro,
            active: isExamHSE,
            content: 'exams',
            linkTo: (hostIsCom ? REACT_APP_URL_EXAMS_COM : REACT_APP_URL_EXAMS) + suffix,
            action: () => {
                if (isExamHSE) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_EXAMS_COM : REACT_APP_URL_EXAMS) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseStart,
            active: isStartHSE,
            content: 'start',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_START_COM : REACT_APP_URL_HSEDESIGN_START_RU) + suffix,
            action: () => {
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_START_COM : REACT_APP_URL_HSEDESIGN_START_RU) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [REACT_APP_URL_HSEDESIGN_COM, REACT_APP_URL_HSEDESIGN_LMS, REACT_APP_URL_HSEDESIGN_LMS_COM, REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU, REACT_APP_URL_HSEDESIGN_RU, REACT_APP_URL_EXAMS_COM, REACT_APP_URL_EXAMS, REACT_APP_URL_HSEDESIGN_START_COM, REACT_APP_URL_HSEDESIGN_START_RU, currentContext, history, isHSEMain, isLMSHSE, isProHSE, isExamHSE, isStartHSE, isVirtualSpace, pathname, suffix, hostIsCom])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'hsedesign'
        }
    }
}import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import useAppTester from "../../../MobileMenu/hooks/useAppTester";
import {useHistory, useLocation} from "react-router-dom";
import {AuthXService} from "@brg/auth";
import {AppTester} from "../../../../supporting";
import {useContextsTabs} from "../../../hooks/useContextsTabs";
import {useMemo} from "react";
import { isServer } from "shared/constants/isServer";

export const useGetHseDesignContexts = () => {

    const {
        isHSEDesign,
        isLMSHSE,
        isProHSE,
        isExamHSE,
        isStartHSE,
    } = useAppTester();
    const isHseColors = AppTester.isContext('hsecolors')
    const { context: currentContext } = useContextsTabs();
    const { pathname } = useLocation();
    const isHSEMain = isHSEDesign && ! isLMSHSE && !isProHSE && !isExamHSE && !isHseColors && !isStartHSE;
    const isVirtualSpace = pathname === '/teams/virtualspace' || pathname.startsWith('/teams/virtualspace/');

    const {
        REACT_APP_URL_HSEDESIGN_COM,
        REACT_APP_URL_HSEDESIGN_RU,
        REACT_APP_URL_HSEDESIGN_LMS_COM,
        REACT_APP_URL_HSEDESIGN_LMS,
        REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU,
        REACT_APP_URL_EXAMS,
        REACT_APP_URL_EXAMS_COM,
        REACT_APP_URL_HSEDESIGN_START_COM,
        REACT_APP_URL_HSEDESIGN_START_RU,
    } = process.env;
    const suffix = AuthXService.isAuthenticated() ? '?shouldLogin=true&saveLoginUrl=true' : '';
    const hostIsCom = !isServer && window.location.origin.includes('com');
    const history = useHistory()

    const links = useMemo(() => ([
        {
            id: ContextCodes.hseDesignMain,
            active: Boolean(currentContext === 'hsedesign_main'),
            content: 'portfolio',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseBooks,
            active: Boolean(currentContext === 'hsebooks'),
            content: 'books',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/hsebooks' + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/hsebooks')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/hsebooks' + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseAnimation,
            active: Boolean(currentContext === 'hseanimation'),
            content: 'animation',
            linkTo: 'https://hseanimation.ru',
            action: () => {
                window.open('https://hseanimation.ru', '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseVisualResearch,
            active: Boolean(currentContext === 'hsevisualresearch'),
            content: 'research',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/visualResearch' + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/visualResearch')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/visualResearch' + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseLMS,
            active: isLMSHSE,
            content: 'lms',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_LMS_COM : REACT_APP_URL_HSEDESIGN_LMS) + suffix,
            action: () => {
                if (isLMSHSE) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_LMS_COM : REACT_APP_URL_HSEDESIGN_LMS) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hsePro,
            active: isProHSE,
            content: 'pro',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_PRO_COM : REACT_APP_URL_HSEDESIGN_PRO_RU) + suffix,
            action: () => {
                if (isProHSE) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_PRO_COM : REACT_APP_URL_HSEDESIGN_PRO_RU) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hsePlaybooks,
            active: Boolean(currentContext === 'hsedesignplaybooks'),
            content: 'playbooks',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/playbooks' + suffix,
            action: () => {
                if (isHSEMain) {
                    history.push('/playbooks')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_COM : REACT_APP_URL_HSEDESIGN_RU) + '/playbooks' + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hsePro,
            active: isExamHSE,
            content: 'exams',
            linkTo: (hostIsCom ? REACT_APP_URL_EXAMS_COM : REACT_APP_URL_EXAMS) + suffix,
            action: () => {
                if (isExamHSE) {
                    history.push('/')
                    return;
                }
                window.open((hostIsCom ? REACT_APP_URL_EXAMS_COM : REACT_APP_URL_EXAMS) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseStart,
            active: isStartHSE,
            content: 'start',
            linkTo: (hostIsCom ? REACT_APP_URL_HSEDESIGN_START_COM : REACT_APP_URL_HSEDESIGN_START_RU) + suffix,
            action: () => {
                window.open((hostIsCom ? REACT_APP_URL_HSEDESIGN_START_COM : REACT_APP_URL_HSEDESIGN_START_RU) + suffix, '_self')
            },

            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [REACT_APP_URL_HSEDESIGN_COM, REACT_APP_URL_HSEDESIGN_LMS, REACT_APP_URL_HSEDESIGN_LMS_COM, REACT_APP_URL_HSEDESIGN_PRO_COM,
        REACT_APP_URL_HSEDESIGN_PRO_RU, REACT_APP_URL_HSEDESIGN_RU, REACT_APP_URL_EXAMS_COM, REACT_APP_URL_EXAMS, REACT_APP_URL_HSEDESIGN_START_COM, REACT_APP_URL_HSEDESIGN_START_RU, currentContext, history, isHSEMain, isLMSHSE, isProHSE, isExamHSE, isStartHSE, isVirtualSpace, pathname, suffix, hostIsCom])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'hsedesign'
        }
    }
}